<!-- Menu header -->
<div class="navbar-header">
  <ul class="nav navbar-nav flex-row">
    <li class="nav-item mr-auto">
      <!-- App Branding -->
      <a class="navbar-brand" [routerLink]="['']">
        <span class="brand-logo">
          <img class="logo-overlay" src="{{ coreConfig.app.appLogoImage }}" alt="brand-logo" />
          <img src="{{ coreConfig.app.appLogoShortImage }}" alt="brand-logo" />
        </span>
        <!-- <h2 class="brand-text mb-0">{{ coreConfig.app.appName }}</h2> -->
      </a>
    </li>

    <!-- Menu Toggler -->
    <li class="nav-item nav-toggle">
      <a class="nav-link modern-nav-toggle d-none d-xl-block pr-0" (click)="toggleSidebarCollapsible()">
        <i [ngClass]="isCollapsed === true ? 'icon-circle' : 'icon-disc'"
          class="toggle-icon feather font-medium-4 collapse-toggle-icon text-secondary"></i>
      </a>
      <a class="nav-link modern-nav-toggle d-block d-xl-none pr-0" (click)="toggleSidebar()">
        <i data-feather="x" class="font-medium-4 text-secondary toggle-icon"></i>
      </a>
    </li>
  </ul>
</div>
<!--/ Menu header -->

<!-- Navbar shadow -->
<div class="shadow-bottom" [ngClass]="{ 'd-block': isScrolled }"></div>

<!-- Main menu -->
<!-- <ng-scrollbar class="main-menu-content" (updated)="onSidebarScroll()">
  <ul class="navigation navigation-main" layout="vertical" xbaht-core-menu></ul>
</ng-scrollbar> -->
<div class="main-menu-content main-menu-content-scroll">
  <ul class="navigation navigation-main" layout="vertical" xbaht-core-menu></ul>
</div>
<!--/ Main menu -->